import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import cloneDeep from 'lodash-es/cloneDeep'
import { accountApi } from 'restApi'
import { FetchStatus, ReferralsState } from 'state/types'

const emptyDirectReferrals = {
  totalMembers: 0,
  totalEarned: 0,
  totalPaidFeesInUsd: 0,
  todayEarnings: 0,
  todayPaidFeesInUsd: 0,
}

const emptyTeam = {
  directReferrals: 0,
  launchPoolMembers: 0,
  totalMembers: 0,
  totalEarned: 0,
  totalPaidFeesInUsd: 0,
  todayEarnings: 0,
  todayPaidFeesInUsd: 0,
  farming: {
    isWeakTeam: false,
    members: 0,
    usdInAllPools: 0,
    usdInNmxPools: 0,
  },
  trading: {
    isWeakTeam: false,
    members: 0,
  },
}

const defaultReferralsState = {
  fetchStatus: FetchStatus.NOT_FETCHED,
  activeReferrals: {
    totalMembers: 0,
  },
  directReferrals: cloneDeep(emptyDirectReferrals),
  leftTeam: cloneDeep(emptyTeam),
  rightTeam: cloneDeep(emptyTeam),
}

const initialState: ReferralsState = cloneDeep(defaultReferralsState)

export const fetchAffiliateInfo = createAsyncThunk('referrals/fetchAffiliateInfo', async () => {
  const { activeReferrals, directReferrals, leftTeam, rightTeam } = await accountApi.getAffiliateInfo()
  return { activeReferrals, directReferrals, leftTeam, rightTeam }
})

export const referralsSlice = createSlice({
  name: 'referrals',
  initialState,
  reducers: {
    resetState: (state) => {
      state.fetchStatus = FetchStatus.NOT_FETCHED
      state.directReferrals = cloneDeep(emptyDirectReferrals)
      state.leftTeam = cloneDeep(emptyTeam)
      state.rightTeam = cloneDeep(emptyTeam)
    },
  },
  extraReducers: (builder) => {
    // fetchAffiliateInfo
    builder.addCase(fetchAffiliateInfo.pending, (state) => {
      state.fetchStatus = FetchStatus.FETCHING
    })
    builder.addCase(fetchAffiliateInfo.fulfilled, (state, action) => {
      state.fetchStatus = FetchStatus.FETCHED
      state.activeReferrals = action.payload.activeReferrals || { totalMembers: 0 }
      state.directReferrals = action.payload.directReferrals
      state.leftTeam = action.payload.leftTeam
      state.rightTeam = action.payload.rightTeam
    })
    builder.addCase(fetchAffiliateInfo.rejected, (state) => {
      state.fetchStatus = FetchStatus.FAILED
      state.activeReferrals = { totalMembers: 0 }
      state.directReferrals = cloneDeep(emptyDirectReferrals)
      state.leftTeam = cloneDeep(emptyTeam)
      state.rightTeam = cloneDeep(emptyTeam)
    })
  },
})

export const { resetState } = referralsSlice.actions

export default referralsSlice.reducer
